"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const newCurrency = currencyItem => {
  const {
    id,
    name,
    rate,
    enabledOnAffilId,
    format,
    precision,
    round
  } = currencyItem;
  return {
    id,
    name,
    code: id.toUpperCase(),
    fallback: null,
    format: {
      format,
      precision: Number(precision || round)
    },
    rate: String(rate),
    enabledOnAffilId
  };
};
const rewriteCurrencies = currencies => Object.fromEntries(Object.entries(currencies).map(_ref => {
  let [key, currency] = _ref;
  const rewriteFallBack = currency.fallback.length > 0 ? newCurrency(currencies[currency.fallback]) : null;
  const c = {
    ...newCurrency(currency),
    fallback: rewriteFallBack
  };
  return [key, c];
}));
var _default = exports.default = rewriteCurrencies;